import { Path, Svg } from 'react-native-svg';

import { type IconProps } from '../types';

export const IconNearMeDisabled = (props: IconProps) => {
  const { size = 16, color, ...otherProps } = props;

  return (
    <Svg
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 32 32"
      color={color ?? 'black'}
      {...otherProps}
    >
      <Path
        fill="currentColor"
        d="M17.5667 28L13.7667 18.2333L4 14.4333V13L11.2333 10.3L3.93333 3L5.36667 1.56667L30.4333 26.6333L29 28.0667L21.7 20.7667L19 28H17.5667ZM23.2667 16.6L15.4 8.73333L28 4L23.2667 16.6Z"
      />
    </Svg>
  );
};
